export default {"src":"/_next/static/media/repair.cd7aa579.svg","height":31,"width":23,"blurWidth":0,"blurHeight":0};